import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi700 } from "../../../../styles/font.constants";
import { spacing } from "../../../../styles/styles.constants";

export const ViewerCommentBar = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 1rem;
	${satoshi700}
	background-color: ${colours.white};
	border-top-left-radius: ${spacing.borderRadius};
	border-top-right-radius: ${spacing.borderRadius};
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	display: flex;
	gap: 0.8rem;
`;
